module.exports = __webpack_public_path__ + "static/media/88.9011dff0.jpg";